/**
 * A headline number.
 *
 * This is the right form for a single value — a one-bar bar chart says nothing a number doesn't,
 * and costs a scale, an axis and a legend to say it. Four of these in a row is a KPI row, not a
 * grouped bar chart.
 *
 * The value keeps the font's proportional figures: `tabular-nums` exists so columns line up
 * vertically, and at this size it makes a number like 121 look loose.
 */
export function StatTile({
  label,
  value,
  hint,
}: {
  /** Sentence case, no trailing colon. */
  label: string;
  value: string;
  /** Optional context under the value — a period, a caveat, a denominator. */
  hint?: string;
}) {
  return (
    <div className="rounded-xl border border-zinc-200 bg-white p-4">
      <p className="text-xs font-medium text-zinc-500">{label}</p>
      <p className="mt-1.5 text-2xl font-semibold text-zinc-900">{value}</p>
      {hint && <p className="mt-0.5 text-xs text-zinc-400">{hint}</p>}
    </div>
  );
}
